import React from 'react';
import cn from 'classnames';
import GhostButton, { GhostButtonProps } from '../GhostButton';

import s from './DividerGhostButton.scss';

interface Props extends Omit<GhostButtonProps, 'variant'> {}

const DividerGhostButton: React.FC<Props> = ({ className, disabled, ...props }) => {
  return (
    <div className={cn(s['root'], disabled && s['disabled'])}>
      <GhostButton
        className={cn(s['button'], className)}
        variant="edit-purple"
        disabled={disabled}
        {...props}
      />
    </div>
  );
};
DividerGhostButton.displayName = 'DividerGhostButton';

export default DividerGhostButton;
